import { Box, Typography, useMediaQuery } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import styles from "../TwoCardTeenPati/styles.module.css";
import BollywoodCasinoimg from "../../../images/BollywoodCasino/bollywood casino.png";
import FooterLinks from "../FooterLinks";
import { useLocation } from "react-router-dom";
import GameScreen from "./GameScreen";
import FlipClock from "../../FlipClock/FlipClock";
import useCasinoBetplace from "../../../api/useCasinoBetplace";
  import useRoundLoader from "../../../api/useRoundLoader";
import RoundLoader from "../../Loader/RoundLoader";

const positions = ["", ""];

const mainRows = [
  { label: "Player A", values: ["1.98"], lock: ["14.33"] },
  { label: "Player B", values: ["1.98"], lock: ["14.33"] },
];

function TwoCardTeenPati({ onBetSelect, locked, socketData, settledData ,hookExposureData}) {
  const [betDialogOpen, setBetDialogOpen] = useState(false);
  const [selectedBet, setSelectedBet] = useState(null);
  const selectionMap = ["PLAYER_A", "PLAYER_B"];
  const remainingTime = socketData?.remainingTime;
  const gameId = socketData?.gameId;
  const roundId = socketData?.roundId;

  const [animTimer, setAnimTimer] = useState(null);
  const resultTime = socketData?.settlement?.resultTime;

useEffect(() => {
    if (hookExposureData === null) {
        setExposureData(null);
        return;
    }
    setExposureData(hookExposureData);
}, [hookExposureData]);

useEffect(() => {
    if (resultTime === 1 || resultTime === 2) {
        setExposureData(null);
    }
}, [resultTime]);

  const [exposureData, setExposureData] = useState(null);
 
  const handleNumberBoxClick = (value, label, rowIdx) => {
    if (!locked) {
      const betData = {
        label: label,
        odds: parseFloat(value),
        betType: "BACK",
        selection: selectionMap[rowIdx],
      };
      setSelectedBet(betData);
      setBetDialogOpen(true);
      if (onBetSelect) {
        onBetSelect(betData);
      }
    }
  };

  const handleBetScreenClose = () => {
    setBetDialogOpen(false);
    setSelectedBet(null);
  };

  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

 const getExposureValue = (rowIdx) => {
    if (!exposureData) return null;
    const val = rowIdx === 0 ? exposureData.playerAWins : exposureData.playerBWins;
    if (val === undefined || val === 0) return null;
    return val;
};

  const ExposureLabel = ({ value }) => {
    if (value === null) return null;
    return (
      <Typography
        sx={{
          width: "100%",
          fontSize: "12px",
          fontWeight: 600,
          color: value < 0 ? "#ff4444" : "#00c853",
          textAlign: "left !important",
          mt: "2px",
          lineHeight: 1,
        }}
      >
        {value}
      </Typography>
    );
  };
  return (
    
      <Box className={styles.MatchScreen_container}>
        <Box sx={{ position: "relative", width: "100%" }}>
          {/* <img src={BollywoodCasinoimg} className={styles.bannerImage_container} /> */}
          {/* <Box className={styles.bannerImage_container} > */}
          <GameScreen
            bettingClosed={socketData?.bettingClosed === true}
            animationTime={
              typeof socketData?.animationTime === "number"
                ? socketData.animationTime
                : undefined
            }
            socketData={socketData}
            settledData={settledData}
            remainingTime={remainingTime}
            onAnimStart={() => setAnimTimer(0)}
            onAnimEnd={() => setAnimTimer(null)}
          />
          <Box>
            <Box>
              {(animTimer !== null || socketData?.remainingTime > 0) && (
                <Box
                  sx={{
                    position: "absolute",
                    bottom: "8px",
                    right: "8px",
                    zIndex: 99,
                    pointerEvents: "none",
                  }}
                >
                  <FlipClock
                    time={
                      animTimer !== null
                        ? animTimer
                        : socketData?.remainingTime || 30
                    }
                  />
                </Box>
              )}
            </Box>
          </Box>

          {/* <Box className={styles.timer_container}>
            <Box className={styles.timer_wrapper}>
              {String(timer).split('').map((digit, index) => (
                <Box key={index} className={styles.timer_box}>
                  <Typography className={styles.timer_txt}>{digit}</Typography>
                </Box>
              ))}
            </Box>
          </Box> */}
        </Box>

        <Box className={styles.box1}>
          {mainRows.map((row, rowIdx) => (
            <Box key={row.label} className={styles.PlayerCardBox}>
              <Box
                className={styles.PlayerCardBoxInner}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start !important",
                  textAlign: "left",
                }}
              >
                <Typography
                  className={styles.PlayerCardText}
                  sx={{ textAlign: "left", width: "100%" }}
                >
                  {row.label}
                </Typography>
                <ExposureLabel value={getExposureValue(rowIdx)} />
              </Box>

              {row.values.map((val, i) => (
                <Box
                  key={`val-${i}`}
                  className={styles.BlueBox}
                  onClick={() =>
                    !locked && handleNumberBoxClick(val, row.label, rowIdx)
                  }
                  sx={{
                    cursor: locked ? "not-allowed" : "pointer",
                    position: "relative",
                  }}
                >
                  <Typography className={styles.BlueBoxText}>{val}</Typography>

                  {locked && (
                    <Box className={styles.bettinglocked_icon_container}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                      >
                        <path
                          d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z"
                          fill="white"
                        />
                      </svg>
                    </Box>
                  )}
                </Box>
              ))}

              {row.lock.map((lockVal, i) => (
                <Box
                  key={`lock-${i}`}
                  className={styles.BlueBox}
                  sx={{ cursor: "not-allowed", position: "relative" }}
                >
                  <Typography className={styles.BlueBoxText}>
                    {lockVal}
                  </Typography>

                  {/* Lock Icon — always visible */}
                  <Box className={styles.bettinglocked_icon_container}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="20"
                      viewBox="0 0 21 20"
                      fill="none"
                    >
                      <path
                        d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z"
                        fill="white"
                      />
                    </svg>
                  </Box>
                </Box>
              ))}
            </Box>
          ))}
        </Box>

        <FooterLinks
          socketData={socketData}
          settledData={settledData}
          gameType="TwoCardTeenPati"
        ></FooterLinks>
      </Box>

  );
}

export default TwoCardTeenPati;
